const SkinStyles = {
  Default: {
    colorPrimary: '#3EC2A2',
  },
  ChinaBank: {
    colorPrimary: '#ED1D2F',
  },
};

export default SkinStyles;
